import { Box, Button, Collapse, IconButton, makeStyles, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import jsPDF from 'jspdf'
import React, { useState, useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { mitraFont } from '../../assets/fonts/Mitra/Mitra'
import { titrFont } from '../../assets/fonts/Titr/Titr'
import { vazirFont } from '../../assets/fonts/vazir-font-v18.0.0/Vazir'
import { gregorianToJalali, thousandsSeparate, toFarsiDigits, toEnglishDigits } from '../../assets/utils'
import { exportExcelMulti, reportMetaNotes, fetchReportQr } from '../../assets/excelUtils'
import { requestsState } from '../../pages/contractor/atoms'
import { userInfoState } from '../../recoil/atoms'
import RequestReportDialog from '../contracts/RequestReportDialog'
import { LoadMoreButton, useIncrementalList } from '../../hooks/useIncrementalList'
import api from '../../api/client';
import { addPdfFooter } from '../../assets/reportFooter'


// خروجی اکسل یک صورت وضعیت: خلاصه + جزئیات حواله‌ها (اعداد واقعی برای جمع‌زدن)
const exportRequestExcel = async (contract, data, detail) => {
    const qr = contract && contract.id ? await fetchReportQr(contract.id) : null
    const prepayment_deduction = detail
        .filter(i => !i.is_interest)
        .reduce((s, i) => s + i.back_prepayment + i.service_life_prepayment, 0)
    const summaryHeaders = [
        'نوع', 'شماره', 'کارکرد', 'بیمه سهم دولت', 'مالیات بر ارزش افزوده', 'جمع هزینه',
        'بیمه (تامین)', 'سپرده', 'پیش پرداخت', 'سایر کسورات', 'جمع کسورات', 'قابل پرداخت',
    ]
    const summaryRows = [[
        data.type,
        data.number,
        data.amount,
        data.insurance,
        data.tax,
        data.sum_amount,
        data.insurance_deduction,
        data.deposit_deduction,
        prepayment_deduction,
        data.other_deduction,
        data.sum_deduction + prepayment_deduction,
        data.sum_amount - (data.sum_deduction + prepayment_deduction),
    ]]
    const detailHeaders = [
        'شماره حواله', 'تاریخ', 'کارکرد', 'بیمه سهم دولت', 'مالیات بر ارزش افزوده', 'جمع هزینه',
        'بیمه', 'سپرده', 'پیش پرداخت', 'سایر', 'جمع کسور', 'قابل پرداخت',
    ]
    const rows = detail.filter(i => !i.is_interest).map(item => {
        const kosorat = item.insurance_deduction + item.deposit_deduction
            + item.back_prepayment + item.service_life_prepayment + item.other_deduction
        const sum = item.amount + item.insurance + item.value_added_tax
        return [
            item.number,
            gregorianToJalali(item.date),
            item.amount,
            item.insurance,
            item.value_added_tax,
            sum,
            item.insurance_deduction,
            item.deposit_deduction,
            item.back_prepayment + item.service_life_prepayment,
            item.other_deduction,
            kosorat,
            sum - kosorat,
        ]
    })
    exportExcelMulti({
        filename: `request_${data.number}.xlsx`,
        title: `صورت وضعیت ${data.number} — ${contract.contractee || ''} | قرارداد ${contract.number || ''}`,
        notes: reportMetaNotes(),
        qrDataUri: qr,
        sections: [
            { caption: 'خلاصه صورت وضعیت', headers: summaryHeaders, rows: summaryRows },
            { caption: 'جزئیات حواله‌ها', headers: detailHeaders, rows: rows },
        ],
    })
}

const printDetails = async (contract, userInfo, data, detail) => {
    const qrData = contract && contract.id ? await fetchReportQr(contract.id) : null
    const doc = new jsPDF('landscape')
    doc.addFileToVFS("Vazir.ttf", vazirFont);
    doc.addFont("Vazir.ttf", "Vazir", "normal");
    doc.addFileToVFS("Titr.ttf", titrFont);
    doc.addFont("Titr.ttf", "Titr", "normal");
    doc.addFileToVFS("Mitra.ttf", mitraFont);
    doc.addFont("Mitra.ttf", "Mitra", "normal");

    doc.setFont('Titr')
    doc.setFontSize(15)

    const textHeight = doc.getTextDimensions('ب').h
    let currentHeight = 5 * textHeight
    const title = contract.contractee
    doc.text(title, doc.internal.pageSize.width / 2, currentHeight, 'center')
    currentHeight += textHeight

    doc.setFontSize(12)
    doc.text('صورت وضعیت', doc.internal.pageSize.width / 2, currentHeight, 'center')
    currentHeight += 2 * textHeight

    doc.setFont('Mitra')
    doc.setFontSize(12)
    const contractorName = userInfo.name
    doc.text(contractorName, 287, currentHeight, 'right')
    currentHeight += textHeight

    let contractTitle = 'قرارداد:  '
    contractTitle += 'شماره  ' + toFarsiDigits(contract.number)
    contractTitle += '  تاریخ  ' + gregorianToJalali(contract.date)
    doc.text(contractTitle, 287, currentHeight, 'right')
    currentHeight += textHeight

    const subject = toFarsiDigits(contract.subject)
    doc.text(subject, 287, currentHeight, 'right')
    currentHeight += textHeight

    // تاریخ گزارش + یادداشت کیوآرکد + خودِ کیوآرکد
    doc.setFont('Mitra')
    doc.setFontSize(9)
    doc.text('تاریخ گزارش: ' + gregorianToJalali(new Date().toISOString().slice(0, 10)), 287, currentHeight, 'right')
    currentHeight += textHeight * 0.9
    if (qrData) {
        doc.text('با اسکن کیوآرکد، این گزارش تا 30 روز در موبایل قابل مشاهده است.', 287, currentHeight, 'right')
        currentHeight += textHeight * 0.9
        try { doc.addImage(qrData, 'PNG', 14, 8, 22, 22) } catch (e) { /* درج QR اختیاری */ }
    }

    let prepayment_deduction = 0
    for (let i = 0; i < detail.length; i++) {
        const item = detail[i]
        if (!item.is_interest) {
            prepayment_deduction += item.back_prepayment + item.service_life_prepayment
        }
    }

    let body = [[
        data.type,
        data.number,
        thousandsSeparate(data.amount),
        thousandsSeparate(data.insurance),
        thousandsSeparate(data.tax),
        thousandsSeparate(data.sum_amount),
        thousandsSeparate(data.insurance_deduction),
        thousandsSeparate(data.deposit_deduction),
        thousandsSeparate(prepayment_deduction),
        thousandsSeparate(data.other_deduction),
        thousandsSeparate(data.sum_deduction + prepayment_deduction),
        thousandsSeparate(data.sum_amount - (data.sum_deduction + prepayment_deduction))
    ].reverse()]

    // Empty row
    body.push([
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
    ].reverse())
    body.push([
        'شماره حواله',
        'تاریخ',
        'کارکرد',
        'بیمه سهم دولت',
        'مالیات بر ارزش افزوده',
        'جمع هزینه',
        'بیمه',
        'سپرده',
        'پیش پرداخت',
        'سایر',
        'جمع کسور',
        'قابل پرداخت',
    ].reverse())


    let sum = {
        amount: 0,
        insurance: 0,
        tax: 0,
        sum_amount: 0,
        insurance_deduction: 0,
        deposit_deduction: 0,
        prepayment_deduction: 0,
        other_deduction: 0,
        sum_deduction: 0,
        sum_amount_after_deduction: 0
    }
    let details_summed = []
    for (let i = 0; i < detail.length; i++) {
        const item = detail[i]
        if (item.is_interest) {
            continue
        }
        if (details_summed.some(x => x.number === item.number)) {
            details_summed.find(x => x.number === item.number).amount += item.amount
            details_summed.find(x => x.number === item.number).insurance += item.insurance
            details_summed.find(x => x.number === item.number).value_added_tax += item.value_added_tax
            details_summed.find(x => x.number === item.number).insurance_deduction += item.insurance_deduction
            details_summed.find(x => x.number === item.number).deposit_deduction += item.deposit_deduction
            details_summed.find(x => x.number === item.number).back_prepayment += item.back_prepayment
            details_summed.find(x => x.number === item.number).service_life_prepayment += item.service_life_prepayment
            details_summed.find(x => x.number === item.number).other_deduction += item.other_deduction
        } else {
            details_summed.push({ ...item })
        }
    }
    for (let i = 0; i < details_summed.length; i++) {
        const item = details_summed[i]
        if (item.is_interest) {
            continue
        }
        body.push([
            item.number,
            gregorianToJalali(item.date),
            thousandsSeparate(item.amount),
            thousandsSeparate(item.insurance),
            thousandsSeparate(item.value_added_tax),
            thousandsSeparate(item.amount + item.insurance + item.value_added_tax),
            thousandsSeparate(item.insurance_deduction),
            thousandsSeparate(item.deposit_deduction),
            thousandsSeparate(item.back_prepayment + item.service_life_prepayment),
            thousandsSeparate(item.other_deduction),
            thousandsSeparate(item.insurance_deduction + item.deposit_deduction + item.back_prepayment + item.service_life_prepayment + item.other_deduction),
            thousandsSeparate((item.amount + item.insurance + item.value_added_tax) - (item.insurance_deduction + item.deposit_deduction + item.back_prepayment + item.service_life_prepayment + item.other_deduction))
        ].reverse())
        sum.amount += item.amount
        sum.insurance += item.insurance
        sum.tax += item.value_added_tax
        sum.sum_amount += item.amount + item.insurance + item.value_added_tax
        sum.insurance_deduction += item.insurance_deduction
        sum.deposit_deduction += item.deposit_deduction
        sum.prepayment_deduction += item.back_prepayment + item.service_life_prepayment
        sum.other_deduction += item.other_deduction
        sum.sum_deduction += item.insurance_deduction + item.deposit_deduction + item.back_prepayment + item.service_life_prepayment + item.other_deduction
        sum.sum_amount_after_deduction += (item.amount + item.insurance + item.value_added_tax) - (item.insurance_deduction + item.deposit_deduction + item.back_prepayment + item.service_life_prepayment + item.other_deduction)
    }
    body.push([
        'جمع حواله ها',
        '',
        thousandsSeparate(sum.amount),
        thousandsSeparate(sum.insurance),
        thousandsSeparate(sum.tax),
        thousandsSeparate(sum.sum_amount),
        thousandsSeparate(sum.insurance_deduction),
        thousandsSeparate(sum.deposit_deduction),
        thousandsSeparate(sum.prepayment_deduction),
        thousandsSeparate(sum.other_deduction),
        thousandsSeparate(sum.sum_deduction),
        thousandsSeparate(sum.sum_amount_after_deduction)
    ].reverse())
    // Empty row
    body.push([
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
    ].reverse())
    body.push([
        'مانده',
        '',
        thousandsSeparate(data.amount - sum.amount),
        thousandsSeparate(data.insurance - sum.insurance),
        thousandsSeparate(data.tax - sum.tax),
        thousandsSeparate(data.sum_amount - sum.sum_amount),
        thousandsSeparate(data.insurance_deduction - sum.insurance_deduction),
        thousandsSeparate(data.deposit_deduction - sum.deposit_deduction),
        thousandsSeparate(prepayment_deduction - sum.prepayment_deduction),
        thousandsSeparate(data.other_deduction - sum.other_deduction),
        thousandsSeparate((data.sum_deduction + prepayment_deduction) - sum.sum_deduction),
        thousandsSeparate((data.sum_amount - (data.sum_deduction + prepayment_deduction)) - sum.sum_amount_after_deduction)
    ].reverse())

    doc.autoTable({
        styles: { font: "Mitra", halign: 'center', valign: 'middle', lineWidth: 0.5, lineColor: 0 },
        head: [[
            'صورت وضعیت',
            'شماره',
            'کارکرد',
            'بیمه سهم دولت',
            'مالیات بر ارزش افزوده',
            'جمع هزینه',
            'بیمه',
            'سپرده',
            'پیش پرداخت',
            'سایر',
            'جمع کسور',
            'قابل پرداخت',
        ].reverse()],
        body: body,
        margin: { top: currentHeight, left: 10, right: 10 },
        theme: 'grid',
        headStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
        bodyStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
    })
    currentHeight = doc.autoTable.previous.finalY + textHeight

    const copyright = 'سامانه ارجان پیمان - شرکت ارجان آرایه پویا'
    doc.text(copyright, 287, currentHeight, 'right')
    currentHeight += 3 * textHeight
    currentHeight = doc.autoTable.previous.finalY + textHeight


    currentHeight = doc.autoTable.previous.finalY + textHeight
    currentHeight += 2 * textHeight
    // Write in the middle at the bottom of the page
    doc.setFont('Titr')
    doc.setFontSize(12)

    addPdfFooter(doc)
    doc.output('dataurlnewwindow', 'details.pdf')
}


const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    button: {
        background: '#8fa8f8',
        '&:hover': {
            background: '#3963f0'
        }
    }
})

const Row = props => {
    const classes = useRowStyles()
    const [detailExpand, setDetailExpand] = useState(false)
    const [documentsExpand, setDocumentsExpand] = useState(false)
    const data = props.data
    const detail = Array.isArray(data.detail) ? [...data.detail] : []
    const documents = Array.isArray(data.documents) ? [...data.documents] : []
    const userInfo = props.userInfo
    const contract = props.contract
    // فیلتر سند: فقط حواله‌های منطبق نمایش داده شوند تا جدول وب با محتوای PDF گزارش یکی باشد
    const docFilter = props.docFilter || 'همه'
    const hasDoc = props.hasAccountingDoc || (t => t && t.document_number != null && String(t.document_number).trim() !== '')
    const visibleDetail = docFilter === 'با سند' ? detail.filter(hasDoc)
        : docFilter === 'بدون سند' ? detail.filter(t => !hasDoc(t))
        : detail
    return (
        <>
            <TableRow className={classes.root}>
                <TableCell align='center'>
                    <Button variant='contained' className={classes.button} onClick={() => printDetails(contract, userInfo, data, visibleDetail)} >
                        چاپ
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        className={classes.button}
                        style={{ marginTop: 6 }}
                        onClick={() => exportRequestExcel(contract, data, visibleDetail)}
                    >
                        دانلود اکسل
                    </Button>
                    <Button
                        variant='outlined'
                        color='primary'
                        className={classes.button}
                        style={{ marginTop: 6 }}
                        onClick={() => props.onOpenReport && props.onOpenReport(data)}
                    >
                        گزارشِ صورت‌وضعیت
                    </Button>
                </TableCell>
                <TableCell align='center'>
                    <IconButton disabled={visibleDetail.length === 0} size='small' onClick={() => {
                        setDocumentsExpand(false)
                        setDetailExpand(!detailExpand)
                    }}>
                        {detailExpand ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </TableCell>
                <TableCell align='center'>
                    <IconButton disabled={documents.length === 0} size='small' onClick={() => {
                        setDetailExpand(false)
                        setDocumentsExpand(!documentsExpand)
                    }}>
                        {documentsExpand ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </TableCell>
                <TableCell align='center'><strong>{toFarsiDigits(props.index)}</strong></TableCell>
                <TableCell align='center'>{toFarsiDigits(data.type)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.number)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.letter_number)}</TableCell>
                <TableCell align='center'>{gregorianToJalali(data.letter_date)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(data.remark)}</TableCell>
                <TableCell align='center'>{gregorianToJalali(data.from_date)}</TableCell>
                <TableCell align='center'>{gregorianToJalali(data.to_date)}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.amount))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.tax))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.insurance))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.sum_amount))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.insurance_deduction))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.deposit_deduction))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.other_deduction))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.sum_deduction))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.net_amount))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.transfer_cash_amount))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.transfer_amount))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.transfer_sum))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.remainder))}</TableCell>
                <TableCell align='center'>{toFarsiDigits(thousandsSeparate(data.transfer_interest))}</TableCell>
            </TableRow>
            <TableRow className={classes.root} style={{ background: '#ecebeb' }}>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan='100%'>
                    <Collapse in={detailExpand} timeout='auto' unmountOnExit>
                        <Box margin={1}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'><strong>ردیف</strong></TableCell>
                                        <TableCell align='center'><strong>سال مالی</strong></TableCell>
                                        <TableCell align='center'><strong>شماره حواله</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ</strong></TableCell>
                                        <TableCell align='center'><strong>شماره سند حسابداری</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ سند حسابداری</strong></TableCell>
                                        <TableCell align='center'><strong>شماره صورت وضعیت</strong></TableCell>
                                        <TableCell align='center'><strong>نوع صورت وضعیت</strong></TableCell>
                                        <TableCell align='center'><strong>شرح</strong></TableCell>
                                        <TableCell align='center'><strong>نقد/اسناد</strong></TableCell>
                                        <TableCell align='center'><strong>اسناد خزانه</strong></TableCell>
                                        <TableCell align='center'><strong>مبلغ</strong></TableCell>
                                        <TableCell align='center'><strong>بیمه</strong></TableCell>
                                        <TableCell align='center'><strong>مالیات بر ارزش افزوده</strong></TableCell>
                                        <TableCell align='center'><strong>پیش پرداخت</strong></TableCell>
                                        <TableCell align='center'><strong>تسویه پیش پرداخت جاری</strong></TableCell>
                                        <TableCell align='center'><strong>تسویه پیش پرداخت سنواتی</strong></TableCell>
                                        <TableCell align='center'><strong>علی الحساب</strong></TableCell>
                                        <TableCell align='center'><strong>تسویه علی الحساب</strong></TableCell>
                                        <TableCell align='center'><strong>جمع کسورات</strong></TableCell>
                                        <TableCell align='center'><strong>گیرنده</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {visibleDetail.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell align='center'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.fiscal_year)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.document_number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.document_date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.request_number)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.request_type)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.remark)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.cash_or_document)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.treasury_document)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.amount))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.insurance))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.value_added_tax))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.prepayment))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.back_prepayment))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.service_life_prepayment))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.on_account))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.back_on_account))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.deduction_sum))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.receiver)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                    <Collapse in={documentsExpand} timeout='auto' unmountOnExit>
                        <Box margin={1}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'><strong>ردیف</strong></TableCell>
                                        <TableCell align='center'><strong>سال مالی سند</strong></TableCell>
                                        <TableCell align='center'><strong>شماره سند</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ سند</strong></TableCell>
                                        <TableCell align='center'><strong>حساب معین</strong></TableCell>
                                        <TableCell align='center'><strong>بدهکار</strong></TableCell>
                                        <TableCell align='center'><strong>بستانکار</strong></TableCell>
                                        <TableCell align='center'><strong>سال مالی حواله</strong></TableCell>
                                        <TableCell align='center'><strong>شماره حواله</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ حواله</strong></TableCell>
                                        <TableCell align='center'><strong>شماره صورت وضعیت</strong></TableCell>
                                        <TableCell align='center'><strong>نوع صورت وضعیت</strong></TableCell>
                                        <TableCell align='center'><strong>شماره چک</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ صدور چک</strong></TableCell>
                                        <TableCell align='center'><strong>تاریخ وصول چک</strong></TableCell>
                                        <TableCell align='center'><strong>مبلغ چک</strong></TableCell>
                                        <TableCell align='center'><strong>حساب گیرنده وجه</strong></TableCell>
                                        <TableCell align='center'><strong>شرح پرداخت</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documents.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell align='center'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.fiscal_year)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.account_subcoding)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.debtor)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.creditor)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.transfer_fiscal_year)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.transfer_number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.transfer_date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.request_number)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.request_type)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.cheque_number)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.cheque_date)}</TableCell>
                                            <TableCell align='center'>{gregorianToJalali(row.cheque_collected_date)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.cheque_amount))}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.account_number)}</TableCell>
                                            <TableCell align='center'>{toFarsiDigits(row.remark)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}


const Requests = props => {
    const requests = useRecoilValue(requestsState)
    const userInfo = useRecoilValue(userInfoState)
    // در موبایل، جعبهٔ اسکرولِ تودرتو حذف می‌شود (خودِ صفحه اسکرول می‌کند)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    // State برای فیلترها
    const [selectedType, setSelectedType] = useState('همه')
    const [selectedYear, setSelectedYear] = useState('همه')
    // فیلتر «سند دار / سند ندار»: سند = شماره سند حسابداری روی خودِ حواله
    const [docFilter, setDocFilter] = useState('همه')
    // جستجوی زندهٔ متن (شماره صورت وضعیت، مبلغ، توضیح و ...)
    const [searchText, setSearchText] = useState('')
    const [liveText, setLiveText] = useState('')
    useEffect(() => {
        const t = setTimeout(() => setSearchText(liveText), 400)
        return () => clearTimeout(t)
    }, [liveText])
    // خطای تولید PDF به‌جایِ سکوت در کنسول، به کاربر نشان داده شود
    const [printError, setPrintError] = useState('')

    // ⭐ State برای نمایش سودها
    const [withInterest, setWithInterest] = useState(false)
    // گزارشِ صورت‌وضعیت (مُدالِ مشترک)
    const [reportRequest, setReportRequest] = useState(null)

    // حواله سند حسابداری دارد؟ '0' در دادهٔ واقعی = بدون سند (shared با ردیف‌های جدول و پارامتر گزارش)
    const hasAccountingDoc = t => {
        if (!t || t.document_number == null) return false
        const v = String(t.document_number).trim()
        return v !== '' && v !== '0' && v !== '۰'
    }
    
    // استخراج انواع صورت وضعیت
    const requestTypes = ['همه', ...Array.from(new Set(
        requests
            .filter(r => r.type && r.type.trim() !== '')
            .map(r => r.type)
    )).sort()]
    
    // استخراج سال مالی از حواله‌ها
    const extractFiscalYears = (request) => {
        if (!request.detail || !Array.isArray(request.detail)) return []
        return request.detail
            .map(transfer => transfer.fiscal_year)
            .filter(year => year != null && String(year).trim() !== '')
    }
    
    const requestYears = ['همه', ...Array.from(new Set(
        requests
            .flatMap(r => extractFiscalYears(r))
    )).sort().reverse()]
    
    // فیلتر کردن صورت‌وضعیت‌ها
    let filteredRequests = requests
    
    if (selectedType !== 'همه') {
        filteredRequests = filteredRequests.filter(r => r.type === selectedType)
    }
    
    if (selectedYear !== 'همه') {
        filteredRequests = filteredRequests.filter(r => {
            const fiscalYears = extractFiscalYears(r)
            return fiscalYears.includes(selectedYear)
        })
    }

    // فیلتر سند: صورت وضعیتی در فهرست می‌ماند که حداقل یک حوالهٔ منطبق داشته باشد
    // (همان منطقِ سرور در تولید PDF — تا عددِ «چاپ همه» با محتوای PDF یکی باشد)
    if (docFilter === 'با سند') {
        filteredRequests = filteredRequests.filter(r =>
            (Array.isArray(r.detail) ? r.detail : []).some(hasAccountingDoc))
    } else if (docFilter === 'بدون سند') {
        filteredRequests = filteredRequests.filter(r =>
            (Array.isArray(r.detail) ? r.detail : []).some(t => !hasAccountingDoc(t)))
    }

    // جستجوی زندهٔ متن — شماره، مبلغ، شرح، نامه و ...
    if (searchText && searchText.trim() !== '') {
        const q = toEnglishDigits(searchText.trim())
        filteredRequests = filteredRequests.filter(r => {
            const values = [
                r.number, r.letter_number, r.remark, r.amount, r.tax, r.insurance,
                r.type, r.from_date, r.to_date,
                ...((Array.isArray(r.detail) ? r.detail : []).flatMap(t => [
                    t.document_number, t.amount, t.cheque_number, t.remark,
                ])),
            ]
            return values.some(v => v !== undefined && v !== null && toEnglishDigits(String(v)).includes(q))
        })
    }

    // رندرِ تدریجی — یک قرارداد می‌تواند تا ۲٬۵۸۴ صورت وضعیت داشته باشد
    const { visible: visibleRequests, hasMore, loadMore, remaining } = useIncrementalList(
        filteredRequests,
        { step: 50, resetKey: `${selectedType}|${selectedYear}|${docFilter}|${searchText}` }
    )

    // ⭐ دانلود مستقیم PDF - دقیقاً مثل PrintReportDialog
    const handlePrintAll = async () => {
        const id = props.contract?.id;
        if (!id) {
          console.warn('Contract id is missing!');
          setPrintError('شناسهٔ قرارداد موجود نیست؛ صفحه را دوباره باز کنید.');
          return;
        }
      
        setPrintError('');
        try {
          
          const token =
            localStorage.getItem('access') ||
            localStorage.getItem('access_token') ||
            localStorage.getItem('token');
      
          const params = {};
          if (selectedType !== 'همه') params.type = selectedType;
          if (selectedYear !== 'همه') params.year = selectedYear;
          if (docFilter === 'با سند') params.doc = 'with';
          else if (docFilter === 'بدون سند') params.doc = 'without';
          if (withInterest) params.with_interest = 'true';
      
          // جلوگیری از 304
          params._ts = Date.now();
      
          const res = await api.get(`/contracts/${id}/report/pdf/`, {
            params,
            responseType: 'blob',
            headers: {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              'Cache-Control': 'no-store',
              Pragma: 'no-cache',
            },
          });
      
          
          const contentType = res.headers?.['content-type'] || '';
          if (!contentType.includes('application/pdf')) {
            // پاسخ، PDF نیست (مثلاً خطای سرور) — متن خطا را بخوان و به کاربر نشان بده
            console.error('Not a PDF response:', contentType);
            let detail = '';
            try {
              const txt = await res.data?.text?.();
              try { const j = JSON.parse(txt); detail = j?.message || j?.detail || j?.error || ''; } catch (_) { detail = txt ? String(txt).slice(0, 160) : ''; }
            } catch (_) { /* blob خوانده نشد */ }
            setPrintError(detail ? `تولید PDF انجام نشد: ${detail}` : 'تولید PDF انجام نشد؛ پاسخ سرور فایل PDF نبود.');
            return;
          }
      
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
      
          // باز شدن در تب جدید
          const win = window.open(url, '_blank', 'noopener,noreferrer');
      
          // اگر پاپ‌آپ بلاک شد، دانلود اجباری
          if (!win) {
            const a = document.createElement('a');
            a.href = url;
            a.download = `contract_report_${id}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
      
          // آزادسازی حافظه
          setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
        } catch (err) {
          console.error('PDF download failed:', err);
          const status = err?.response?.status;
          setPrintError(
            status === 401 || status === 403
              ? 'نشست شما پایان یافته است؛ لطفاً خارج شوید و دوباره وارد شوید.'
              : `تولید PDF انجام نشد${err?.message ? ` (${err.message})` : '.'}`
          );
        }
      };
      
    
    // ⭐ دانلود اکسل - همان فیلترها، خروجی xlsx برای کار مالی
    const handleExcelDownload = async () => {
        const id = props.contract?.id;
        if (!id) {
          setPrintError('شناسهٔ قرارداد موجود نیست؛ صفحه را دوباره باز کنید.');
          return;
        }
        setPrintError('');
        try {
          const token =
            localStorage.getItem('access') ||
            localStorage.getItem('access_token') ||
            localStorage.getItem('token');

          const params = {};
          if (selectedType !== 'همه') params.type = selectedType;
          if (selectedYear !== 'همه') params.year = selectedYear;
          if (docFilter === 'با سند') params.doc = 'with';
          else if (docFilter === 'بدون سند') params.doc = 'without';
          if (withInterest) params.with_interest = 'true';
          params._ts = Date.now();

          const res = await api.get(`/contracts/${id}/report/excel/`, {
            params,
            responseType: 'blob',
            headers: {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              'Cache-Control': 'no-store',
              Pragma: 'no-cache',
            },
          });

          const contentType = res.headers?.['content-type'] || '';
          if (!contentType.includes('spreadsheetml')) {
            console.error('Not an xlsx response:', contentType);
            let detail = '';
            try {
              const txt = await res.data?.text?.();
              try { const j = JSON.parse(txt); detail = j?.message || j?.detail || j?.error || ''; } catch (_) { detail = txt ? String(txt).slice(0, 160) : ''; }
            } catch (_) { /* blob خوانده نشد */ }
            setPrintError(detail ? `ساخت فایل اکسل انجام نشد: ${detail}` : 'ساخت فایل اکسل انجام نشد؛ پاسخ سرور فایل اکسل نبود.');
            return;
          }

          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          const cn = String(props.contract?.number || id).replace(/\//g, '_');
          a.download = `contract_report_${cn}.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
        } catch (err) {
          console.error('Excel download failed:', err);
          const status = err?.response?.status;
          setPrintError(
            status === 401 || status === 403
              ? 'نشست شما پایان یافته است؛ لطفاً خارج شوید و دوباره وارد شوید.'
              : `ساخت فایل اکسل انجام نشد${err?.message ? ` (${err.message})` : '.'}`
          );
        }
      };

    const useButtonStyles = makeStyles({
        filterButton: {
            margin: '0 5px',
            minWidth: '80px',
            background: '#e0e0e0',
            '&:hover': {
                background: '#bdbdbd'
            }
        },
        activeButton: {
            margin: '0 5px',
            minWidth: '80px',
            background: '#8fa8f8',
            color: 'white',
            '&:hover': {
                background: '#3963f0'
            }
        }
    })
    
    const buttonClasses = useButtonStyles()
    
    return (
        <>
            {/* فیلترها */}
            <div style={{ 
                padding: '10px 20px', 
                background: '#f5f5f5', 
                borderRadius: '4px',
                marginBottom: '10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px'
            }}>
                {/* فیلتر نوع */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold', minWidth: '150px' }}>
                        فیلتر بر اساس نوع:
                    </Typography>
                    {requestTypes.map(type => (
                        <Button
                            key={type}
                            variant="contained"
                            className={selectedType === type ? buttonClasses.activeButton : buttonClasses.filterButton}
                            onClick={() => setSelectedType(type)}
                        >
                            {toFarsiDigits(type)}
                        </Button>
                    ))}
                </div>
                
                {/* فیلتر سال مالی */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold', minWidth: '150px' }}>
                        فیلتر بر اساس سال مالی:
                    </Typography>
                    {requestYears.map(year => (
                        <Button
                            key={year}
                            variant="contained"
                            className={selectedYear === year ? buttonClasses.activeButton : buttonClasses.filterButton}
                            onClick={() => setSelectedYear(year)}
                        >
                            {toFarsiDigits(year)}
                        </Button>
                    ))}
                </div>

                {/* فیلتر سند حسابداری */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold', minWidth: '150px' }}>
                        فیلتر بر اساس سند:
                    </Typography>
                    {['همه', 'با سند', 'بدون سند'].map(doc => (
                        <Button
                            key={doc}
                            variant="contained"
                            className={docFilter === doc ? buttonClasses.activeButton : buttonClasses.filterButton}
                            onClick={() => setDocFilter(doc)}
                        >
                            {doc}
                        </Button>
                    ))}
                </div>

                {/* ⭐ فیلتر نمایش سودها */}
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '20px', 
                    flexWrap: 'wrap',
                    paddingTop: '10px',
                    borderTop: '1px solid #ddd'
                }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold', minWidth: '150px' }}>
                        گزارش PDF:
                    </Typography>
                    
                    <label style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px',
                        cursor: 'pointer',
                        padding: '8px 15px',
                        borderRadius: '4px',
                        background: !withInterest ? '#e3f2fd' : 'transparent',
                        border: !withInterest ? '2px solid #2196f3' : '2px solid #ddd'
                    }}>
                        <input
                            type="radio"
                            name="interestOption"
                            checked={!withInterest}
                            onChange={() => setWithInterest(false)}
                            style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                        />
                        <span style={{ fontSize: '14px' }}>بدون حفظ قدرت خرید (نمایش سودها)</span>
                    </label>
                    
                    <label style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px',
                        cursor: 'pointer',
                        padding: '8px 15px',
                        borderRadius: '4px',
                        background: withInterest ? '#e3f2fd' : 'transparent',
                        border: withInterest ? '2px solid #2196f3' : '2px solid #ddd'
                    }}>
                        <input
                            type="radio"
                            name="interestOption"
                            checked={withInterest}
                            onChange={() => setWithInterest(true)}
                            style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                        />
                        <span style={{ fontSize: '14px' }}>با حفظ قدرت خرید (نمایش سودها)</span>
                    </label>
                </div>
                
                {/* نمایش تعداد نتایج و دکمه چاپ همه */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" style={{ color: '#666', fontStyle: 'italic' }}>
                        تعداد نتایج: {toFarsiDigits(filteredRequests.length)} مورد
                    </Typography>
                    
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {/* ⭐ دکمه چاپ همه - مستقیم */}
                        <Button
                            variant="contained"
                            onClick={handlePrintAll}
                            disabled={filteredRequests.length === 0}
                            style={{
                                background: filteredRequests.length === 0 ? '#ccc' : '#4caf50',
                                color: 'white',
                                padding: '8px 25px',
                                fontSize: '14px',
                                fontWeight: 'bold'
                            }}
                        >
                            چاپ همه ({toFarsiDigits(filteredRequests.length)} مورد)
                        </Button>
                        {/* ⭐ دکمه دانلود اکسل - همان فیلترها */}
                        <Button
                            variant="contained"
                            onClick={handleExcelDownload}
                            disabled={filteredRequests.length === 0}
                            style={{
                                background: filteredRequests.length === 0 ? '#ccc' : '#0277bd',
                                color: 'white',
                                padding: '8px 25px',
                                fontSize: '14px',
                                fontWeight: 'bold'
                            }}
                        >
                            دانلود اکسل ({toFarsiDigits(filteredRequests.length)} مورد)
                        </Button>
                    </div>
                </div>
            </div>

            {/* جستجوی زندهٔ متن — زیر گزینه‌ها و بالای لیست */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginTop: 10, paddingTop: 10, borderTop: '1px solid #ddd' }}>
                <Typography variant="body1" style={{ fontWeight: 'bold', minWidth: '150px' }}>
                    جستجو:
                </Typography>
                <TextField
                    size="small"
                    variant="outlined"
                    placeholder="شماره، مبلغ، شرح ... (همان لحظه)"
                    style={{ minWidth: 260, background: '#fff', borderRadius: 8 }}
                    value={liveText}
                    onChange={(e) => setLiveText(e.target.value)}
                />
            </div>

            <TableContainer
                elevation={5}
                component={Paper}
                style={isMobile ? undefined : { maxHeight: '450px' }}
            >
                <Table stickyHeader={!isMobile}>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'><strong>چاپ</strong></TableCell>
                            <TableCell align='center'><strong>حواله ها</strong></TableCell>
                            <TableCell align='center'><strong>سند حسابداری</strong></TableCell>
                            <TableCell align='center'><strong>ردیف</strong></TableCell>
                            <TableCell align='center'><strong>نوع وضعیت</strong></TableCell>
                            <TableCell align='center'><strong>شماره صورت وضعیت</strong></TableCell>
                            <TableCell align='center'><strong>شماره درخواست</strong></TableCell>
                            <TableCell align='center'><strong>تاریخ درخواست</strong></TableCell>
                            <TableCell align='center'><strong>توضیحات</strong></TableCell>
                            <TableCell align='center'><strong>از تاریخ</strong></TableCell>
                            <TableCell align='center'><strong>تا تاریخ</strong></TableCell>
                            <TableCell align='center'><strong>مبلغ کارکرد</strong></TableCell>
                            <TableCell align='center'><strong>مالیات بر ارزش افزوده</strong></TableCell>
                            <TableCell align='center'><strong>بیمه سهم دولت</strong></TableCell>
                            <TableCell align='center'><strong>جمع کل</strong></TableCell>
                            <TableCell align='center'><strong>کسور بیمه</strong></TableCell>
                            <TableCell align='center'><strong>کسور سپرده</strong></TableCell>
                            <TableCell align='center'><strong>سایر کسور</strong></TableCell>
                            <TableCell align='center'><strong>جمع کسورات</strong></TableCell>
                            <TableCell align='center'><strong>خالص صورت وضعیت</strong></TableCell>
                            <TableCell align='center'><strong>حواله نقدی</strong></TableCell>
                            <TableCell align='center'><strong>حواله اسناد خزانه</strong></TableCell>
                            <TableCell align='center'><strong>جمع حواله</strong></TableCell>
                            <TableCell align='center'><strong>مانده صورت وضعیت</strong></TableCell>
                            <TableCell align='center'><strong>سود حواله</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {visibleRequests.map((data, index) => (<Row key={data.id} data={data} userInfo={userInfo} contract={props.contract} index={index + 1} docFilter={docFilter} hasAccountingDoc={hasAccountingDoc} onOpenReport={setReportRequest} />))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* رندرِ تدریجی — یک قرارداد می‌تواند تا ۲٬۵۸۴ صورت وضعیت داشته باشد */}
            <LoadMoreButton
                hasMore={hasMore}
                remaining={remaining}
                onClick={loadMore}
            />

            {/* خطای تولید PDF — به‌جای سکوت، به کاربر نشان داده می‌شود */}
            <Snackbar
                open={Boolean(printError)}
                autoHideDuration={9000}
                onClose={() => setPrintError('')}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setPrintError('')} severity="error" variant="filled">
                    {printError}
                </Alert>
            </Snackbar>

            {/* گزارشِ صورت‌وضعیت (مشترک با پنل ناظر/مشاور) */}
            <RequestReportDialog
                open={!!reportRequest}
                contractId={props.contract?.id}
                requestId={reportRequest?.id}
                onClose={() => setReportRequest(null)}
            />
        </>
    )
}
export default Requests